<template>
  <div class="home" id="home">
    <header class="container">
      <div class="header">
        <div class="logo-mobile">
          <img src="../assets/logo-icon.png">
        </div>
        <div class="hamburger" @click="menu_opened = !menu_opened">
          <img src="../assets/hamb.png">
        </div>
        <div class="logo">
          <img src="../assets/logo.png">
        </div>
        <div class="menu" :class="{ opened: menu_opened }">
          <div class="close" @click="menu_opened = !menu_opened">X</div>
          <div class="logo-mobile">
            <img src="../assets/logo-icon.png">
          </div>
          <ul>
            <li @click.prevent="scrollTo('#next-events')">Corridas</li>
            <li @click.prevent="scrollTo('#partners')">Parcerias</li>
            <li @click.prevent="scrollTo('#gallery')">Galeria de Fotos</li>
            <li class="contact"><a href="mailto:pilotoarthurscherer@gmail.com?subject=[Website] Contato">Contato</a></li>
          </ul>
        </div>
      </div>
      <div class="bio">
        <img src="../assets/play.svg" class="play-home" @click.prevent="video = true" />
        <h1>ARTHUR SCHERER</h1>
        <p>Nascido em 9 de Abril de 1996, São Paulo - SP. Estudante de Design de Produtos, com ênfase na area automobilistica, no IMT - Instituto Mauá de Tecnologia. Esportista desde a infância, participando de várias competições em diversos esportes, porém sua grande paixão sempre foi uma só, o automobilismo. Desde pequeno, acompanha diversas categorias de corridas ao redor do mundo.</p>
        <a class="btn abt" @click.prevent="about=true">Saiba mais</a>
      </div>
<!--       <div class="video-background">
        <div class="video-foreground">
          <iframe src="https://www.youtube.com/embed/gUZj8zd3R9c?controls=0&showinfo=0&rel=0&autoplay=1&loop=1&mute=1&playlist=gUZj8zd3R9c" frameborder="0" allow="autoplay" allowfullscreen></iframe>
        </div>
      </div> -->
    </header>

    <img src="../assets/arrow.svg" class="arrow" />

    <section class="container twitter-section">
      <h1>Últimas novidades no Twitter</h1>
      <p>Fique de olho nas novidades da minha trajetória</p>
      <div class="twitter">
        <a class="twitter-timeline" data-lang="pt" data-height="600" data-width="100%" data-theme="dark" href="https://twitter.com/ArthurSchererpi?ref_src=twsrc%5Etfw">Tweets by ArthurSchererpi</a> <script src="https://platform.twitter.com/widgets.js" type="application/javascript"></script>
      </div>
      <!-- <div class="twitter-cards">
        <div class="card" v-for="(card, i) in twitter_cards" :key="i">{{card}}</div>
      </div> -->
    </section>

    <img src="../assets/arrow.svg" class="arrow" />

    <section class="container next-events" id="next-events">
      <div class="info">
        <h1>Próximas Corridas</h1>
        <p>Fique por dentro das próximas corridas que irão acontecer!</p>
      </div>
      <!-- <div class="slideshow">

        <div class="card" v-show="slides[0]">
          <div class="content">
            <p>1ª ETAPA</p>
            <div class="info">
              <h2>Campeonato Paulista de F1600</h2>
              <div class="hours">
                <p>TL  - 08:00 as 09:00 / 15:00 as 16:00</p>
                <p>Q - 09:00 as 09:30</p>
                <p>RC1 - 09:00  / RC2 - 14:00</p>
              </div>
              <p class="lead"><img src="../assets/local.svg" class="icon" /> Autódromo de Interlagos</p>
            </div>
          </div>
          <img src="../assets/local.png" class="road" />
        </div>
        <a class="prev" @click.prevent="showSlide(slide-1)"><img src="../assets/arrow-left.png" /></a>
        <a class="next" @click.prevent="showSlide(slide+1)"><img src="../assets/arrow-right.png" /></a>

      </div> -->

      <div class="next-events-cards">
        <div class="card-fixed">
          <div class="content">
            <p>5ª ETAPA - 24 DE OUTUBRO</p>
            <div class="info">
              <h2>Campeonato Paulista de F1600</h2>
              <div class="hours">
                <p>TL  - 08:00 as 09:00 / 15:00 as 16:00</p>
                <p>Q - 09:00 as 09:30</p>
                <p>RC1 - 09:00  / RC2 - 14:00</p>
              </div>
              <p class="lead"><img src="../assets/local.svg" class="icon" /> Autódromo de Interlagos</p>
            </div>
          </div>
          <img src="../assets/local.png" class="road" />
        </div>

        <div class="card-secondary">
          <div class="content">
            <p>5ª ETAPA - 24 DE OUTUBRO</p>
            <div class="info">
              <div class="hours">
                <p>TL  - 08:00 as 09:00 / 15:00 as 16:00</p>
                <p>Q - 09:00 as 09:30</p>
                <p>RC1 - 09:00  / RC2 - 14:00</p>
              </div>
              <p class="lead"><img src="../assets/local.svg" class="icon" /> Autódromo de Interlagos</p>
            </div>
          </div>
          <div class="map">
            <img src="../assets/road.svg" class="road" />
          </div>
        </div>

        <div class="card-secondary">
          <div class="content">
            <p>5ª ETAPA - 24 DE OUTUBRO</p>
            <div class="info">
              <div class="hours">
                <p>TL  - 08:00 as 09:00 / 15:00 as 16:00</p>
                <p>Q - 09:00 as 09:30</p>
                <p>RC1 - 09:00  / RC2 - 14:00</p>
              </div>
              <p class="lead"><img src="../assets/local.svg" class="icon" /> Autódromo de Interlagos</p>
            </div>
          </div>
          <div class="map">
            <img src="../assets/road.svg" class="road" />
          </div>
        </div>
      </div>

      <ul class="legends">
        <li>TL - Treino Livre</li>
        <li>Q - Qualificação</li>
        <li>RC - Corrida</li>
      </ul>
    </section>

    <img src="../assets/arrow.svg" class="arrow" />

    <section class="container titles" id="titles">
      <h1><img src="../assets/throphy.png" alt="Throphy" class="throphy"> Títulos</h1>
      <p>Estes são os títulos que já conquistei na minha carreira</p>
      <div class="list-titles">
        <div class="title">
          <img src="../assets/f1600.png" class="f1600" />
          <h1>Vice Campeão Paulista F1600 • 2019</h1>
          <div class="icon">🇧🇷</div>
        </div>
        <div class="divisor"></div>
        <div class="title">
          <img src="../assets/amika.png" class="amika" />
          <h1>3° colocado Novatos AMIKA • 2018</h1>
          <div class="icon">🇺🇸</div>
        </div>
      </div>
    </section>

    <img src="../assets/arrow.svg" class="arrow" />

    <section class="container partners" id="partners">
      <h1>Parcerias realizadas</h1>
      <p>Estas são algumas das parcerias já realizadas na minha carreira</p>
      <div class="partners-img">
        <img src="../assets/partners/scherer.png" class="partner" />
        <img src="../assets/partners/tecfil.png" class="partner" />
        <img src="../assets/partners/sabo.png" class="partner" />
        <img src="../assets/partners/sampel.png" class="partner" />
      </div>

      <a href="mailto:pilotoarthurscherer@gmail.com?subject=[Website] Quero fazer parceria" class="btn">Quero fazer parceria!</a>
    </section>

    <img src="../assets/arrow.svg" class="arrow" />

    <section class="container instagram" id="gallery">
      <h1>Galeria de fotos</h1>
      <ul class="instagram-grid">
        <li v-for="image in images" :key="image.id">
          <a :href="image.link" target="_blank"><img :src="image.image" /></a>
        </li>
      </ul>
      <a href="https://www.instagram.com/arthurschererpiloto" target="_blank" class="btn">Conhecer Instagram</a>
    </section>

    <footer class="container">
      <nav>
        <img src="../assets/logo-icon.png" class="logo-icon" @click.prevent="scrollTo('#home')" />
        <ul class="nav-footer">
          <li @click.prevent="scrollTo('#next-events')">Corridas</li>
          <li @click.prevent="scrollTo('#home')">Sobre mim</li>
          <li @click.prevent="scrollTo('#partners')">Parcerias</li>
          <li @click.prevent="scrollTo('#gallery')">Galeria de Fotos</li>
        </ul>
      </nav>
      <div class="social-media">
        <a href="https://www.instagram.com/arthurschererpiloto" target="_blank"><img src="../assets/instagram.png" class="icon-social" /></a>
        <a href="https://www.facebook.com/arthurschererpiloto" target="_blank"><img src="../assets/facebook.png" class="icon-social" /></a>
      </div>
    </footer>

    <div class="scrollup" @click.prevent="scrollTo('#home')" :class="{ 'scrollup-hide': menu_opened }">^</div>

    <!-- modal video -->
    <div class="video-modal" v-if="video">
      <div class="content">
        <div class="close" @click.prevent="video = false">X</div>
        <iframe src="https://www.youtube.com/embed/gUZj8zd3R9c?controls=1&showinfo=1&rel=0&autoplay=1&loop=1&mute=0" frameborder="0" allow="autoplay" allowfullscreen></iframe>
      </div>
    </div>

    <div class="video-modal" v-if="about">
      <div class="content about-modal">
        <div class="close" @click.prevent="about = false">X</div>
        <div class="about-full">
          Nascido em 9 de Abril de 1996, São Paulo - SP.
          Estudante de Design de Produtos, com ênfase na area automobilistica, no IMT - Instituto Mauá de Tecnologia.
          Iniciou sua carreira em fevereiro de 2018, inscrevendo-se em um campeonato de kart amador e já na 1ª temporada, mesmo participando de poucas corridas, alcançou excelentes resultados. 
          Foco e determinação não faltam ao Arthur. Tendo como meta, crescer no esporte proﬁssional. 
          <br>
          Assim, em 2019, iniciou sua carreira como piloto proﬁssional na F1600, pela equipe SanRace, participando da temporada do Campeonato Paulista de Velocidade no Asfalto da FASP. 
          Em 2019 Consagrou-se Vice-Campeão Paulista da F1600 Brasil na divisão light. 
          Com isso irá disputar pelo titulo na divisão pricipal da F1600 Brasil em 2020.
        </div>
        <div class="profile">
          <img src="../assets/scherer.png" class="scherer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data(){
    return {
      images: null,
      video: false,
      about: false,
      menu_opened: false,
      slide: 0,
      slides: [1],
      twitter_cards: []
    }
  },
  props: {
    msg: String
  },
  methods: {
    scrollTo(selector){
      this.menu_opened = false;
      document.querySelector(selector).scrollIntoView({behavior: 'smooth'});
    },
    showSlide(n) {
      let slides = document.querySelectorAll('.card');
      this.slide = n;
      if (n >= slides.length){this.slide = 0}
      if (n < 0) {this.slide = slides.length-1}

      console.log(this.slide);
      this.slides = [];
      for (let i = 0; i < slides.length; i++) {
        this.slides.push(0);
      }
      this.slides[this.slide] = 1;
    },
    async getTweets(){
      //curl "https://api.twitter.com/1.1/statuses/user_timeline.json?user_id=1286357812088627200&screen_name=arthurschererpi&count=3" -H "Authorization: Bearer AAAAAAAAAAAAAAAAAAAAANqyIQEAAAAAKGx6f%2FLsLbfPQ%2F82q2ojYwBLOqc%3Da3niHJ1ibLLiKPz6kWV8RBXRErD4twUD40YjCM5frkOAQ71qVd"
      // let at = 'AAAAAAAAAAAAAAAAAAAAANqyIQEAAAAAKGx6f%2FLsLbfPQ%2F82q2ojYwBLOqc%3Da3niHJ1ibLLiKPz6kWV8RBXRErD4twUD40YjCM5frkOAQ71qVd';
      let url = 'https://api.twitter.com/1.1/statuses/user_timeline.json?user_id=1286357812088627200&screen_name=arthurschererpi&count=3';
      const tweets = await fetch(url, {
        mode: 'no-cors',
        method: 'GET',
        headers: {
          Authorization: "Bearer AAAAAAAAAAAAAAAAAAAAANqyIQEAAAAAKGx6f%2FLsLbfPQ%2F82q2ojYwBLOqc%3Da3niHJ1ibLLiKPz6kWV8RBXRErD4twUD40YjCM5frkOAQ71qVd",
        }
      });
      console.log(tweets);
      if(tweets){
        let cards = [];
        for (let i = 0; i < tweets.length; i++) {
          console.log(element);
          const element = tweets[i];
          let oembed = 'https://publish.twitter.com/oembed?url=https%3A%2F%2Ftwitter.com%2FInterior%2Fstatus%2F'+element.id_str;
          const card = await fetch(oembed);
          console.log(card);
          cards.push(card.html);
        }
        this.twitter_cards = cards;
      }

    },
    getInstagram(){
      let access_token = 'IGQVJVU1dJNm1QRFJKT0hGWmREbGQ5cV9FTFZA6cnZAMaDBkZAjhacGo0ZAWF2ZAnBWU21RWTlsa0dHU1NhMDRVZA19sMGF1NU5tdTVxbzJzSDh3dHowOFJmbk1ZATWQwUGpET0xXM3BFM2VvX18xbkd4QUNESwZDZD';
      fetch('https://graph.instagram.com/me?fields=media&access_token='+access_token).then(r => r.json()).then(data => {
        let images = [];
        // console.log(data);
        for (var i = 0; i < 6; i++) {
          let media_id = data.media.data[i].id;
          fetch('https://graph.instagram.com/'+media_id+'?fields=id,permalink,thumbnail_url,media_url&access_token='+access_token).then(r => r.json()).then(image => {
            // console.log(image);
            images.push({
              id: image.id,
              link: image.permalink,
              image: image.media_url
            });
          })
        }
        this.images = images;
      })
    }
  },
  created(){
    // slideshow
    this.showSlide(0);
    this.getInstagram();
    // this.getTweets();

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home{
  display: flex;
  flex-direction: column;
  justify-content: center;
  color:#fff;
}

.container{
  padding:60px;
}

.arrow{
  max-height:250px;
}

.btn{
  background: #fff;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 150.2%;
  color: #010101;
  text-decoration: none;
  padding:10px 20px;

  &:hover{
    opacity: 0.9;
  }
}

header{
  // background-color: red;
  background-image: url('../assets/header.png');
  background-size:cover;
  background-position:center center;
  height:800px;
  width:100%;
  position:relative;
  z-index: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 56.25%; /*16:9*/
  overflow: hidden;

  p{
    color:#fff;
  }

  h1{
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 42px;
    line-height: 51px;
    letter-spacing: 0.09em;
    color: #fff;
  }
}

header::after{
  position: absolute;
  content: '';
  left: 0;
  top: 0;
  right:0;
  bottom: 0;
  background: rgba(0, 0, 0, .14);
  background-image: linear-gradient(transparent, black);
  z-index: -1;
}

.header{
  display: flex;
  justify-content: space-between;
  // background:green;
  align-items: center;

  .menu{
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 150.2%;
    color: #FFFFFF;
    ul{
      list-style: none;
    }
    li{
      display: inline-block;
      padding:15px 20px;
      margin:0 10px;
      cursor: pointer;

      &:hover{
        text-decoration: underline;
      }
    }
    .contact{
      background-color: #fff;
      a{
        color:#010101;
        text-decoration: none;
      }
      &:hover{
        text-decoration: none;
      }
    }
  }
}

.bio{
  width:700px;
  .play-home{
    cursor: pointer;
    &:hover{
      opacity: 0.7;
    }
  }
  p{
    margin-bottom: 15px;
  }
  .abt{
    margin:10px 0;
    cursor: pointer;
  }
}

.video-background {
  display: none;
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  z-index: -2;
}
.video-foreground,
.video-background iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}


@media (min-aspect-ratio: 16/9) {
  .video-foreground { padding-bottom: calc(var(--aspect-ratio, .5625) * 100%);  }
}

@media (max-aspect-ratio: 16/9) {
  .video-foreground { padding-bottom: calc(var(--aspect-ratio, .5625) * 100%); }
}

@media screen and (min-width: 1423px) {
  .video-background{
    display: block;
  }
}

// proximos eventos
.next-events{
  display: flex;
  flex-direction: column;
  justify-content: center;

  .slideshow {
    position:relative;
    max-width:50%;
    margin:0 auto;

    .prev, .next {
      cursor: pointer;
      position: absolute;
      top: 40%;
      width: auto;
      margin-top: -22px;
      padding: 16px;
      color: white;
      font-weight: bold;
      font-size: 18px;
      transition: 0.6s ease;
      border-radius: 0 3px 3px 0;
      user-select: none;
    }

    .prev{
      left:-50px;
    }

    .next {
      right:-50px;
      border-radius: 3px 0 0 3px;
    }
  }

  & > .info{
    text-align: center;
    padding:30px 0;
  }

  .card{
    display:flex;
    background: #212121;
    padding:40px;
    justify-content: center;
    align-items:center;
    margin:0 auto;

    .content{
      margin:0 30px;
    }

    .info{
      margin-bottom:20px;

      .hours{
        margin:15px 0;
      }
    }
  }

  .card-fixed{
    display:flex;
    background: #212121;
    padding:40px;
    justify-content: center;
    align-items:center;
    margin:0 auto;
    max-width:1030px;
    border-radius: 21px;
    max-width:1030px;
    flex-wrap: wrap;

    .lead{
      display:flex;
      justify-content: flex-start;
      align-items: center;

      .icon{
        margin-right:10px;
      }
    }

    .content{
      margin:0 30px;
    }

    .info{
      margin-bottom:20px;

      .hours{
        margin:15px 0;
      }
    }
  }

  .card-secondary{
    display:flex;
    padding:20px 20px;
    flex-wrap: wrap;
    align-items:center;
    justify-content: space-between;
    margin:0 auto;
    max-width:860px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.6);

    .content{
      margin:0 50px;
    }

    .road{
      max-height:150px;
    }

    .map{
      display: flex;
      justify-content: center;
      align-self: center;
      padding:0 10%;
      margin:0 auto;
    }

    .lead{
      display:flex;
      justify-content: flex-start;
      align-items: center;

      .icon{
        margin-right:10px;
      }
    }

    .info{
      margin-bottom:20px;

      .hours{
        margin:15px 0;
      }
    }
  }

  .legends{
    margin:20px auto;
    max-width:50%;
    list-style: none;
    li{
      display:inline-block;
      margin:0 10px;
    }
  }
}


// parceiros
.partners{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;

  .partner{
    margin:20px 40px;
  }
}


// titles
.titles{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;

  h1{
    display:flex;
    align-items:center;
    margin:10px 0;
  }

  .throphy{
    margin:0 10px;
  }

  .divisor{
    height:1px;
    width:100%;
    background:rgba(255, 255, 255, 0.5);
  }
  
  .title{
    display: flex;
    align-items:center;
    justify-content: space-between;
    margin:30px 40px;

    img{
      max-height:60px;
    }

    h1{
      margin:0 10px;
      font-size:20px;
    }

    .icon{
      font-size:40px;
    }
  }
}

// instagram
.instagram{
  h1{
    margin:20px 0;
  }
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items:center;

  .btn{
    margin-top:30px;
  }

  img{
    height: 289px;
    width: 340px;
    object-fit: cover; /* Do not scale the image */
    object-position: center; /* Center the image within the element */
  }
}

.instagram-grid {
  display:grid;
  grid-template-columns: 340px 340px 340px;
  list-style: none;
}

.instagram-grid li{
  position:relative;
  z-index: 0;
  cursor: pointer;
  height: 289px;
  width: 340px;

  a:hover::after{
    position: absolute;
    content: '';
    left: 0;
    top: 0;
    right:0;
    bottom:0;
    background: #000;
    background-image: url('../assets/icon-instagram.png');
    background-position: center center;
    background-repeat: no-repeat;
    z-index: 2;
    opacity: 0.6;
  }
}

//footer
footer{
  display: flex;
  justify-content: space-between;
  align-items: center;

  .logo-icon{
    cursor: pointer;
  }

  nav{
    display: flex;
    justify-content: center;
    align-items:center;
    img{
      margin-right:20px;
    }
    ul{
      list-style: none;
      li{
        display: inline-block;
        margin: 0 30px;
        cursor: pointer;
        &:hover{
          text-decoration: underline;
        }
      }
    }
  }
}

// scrollup
.scrollup{
  position:fixed;
  background:#fff;
  color:#010101;
  bottom:20px;
  right:20px;
  padding:10px 15px;
  font-size:30px;
  cursor: pointer;
}

.scrollup-hide{
  display: none;
}

//video modal
.video-modal{
  position:fixed;
  top:0;
  left:0;
  right:0;
  bottom:0;
  background:#010101;
  padding:20px;
  overflow-y: auto;

  margin:0 auto;

  .close{
    background:#fff;
    color:#000;
    padding:12px 20px;
    width:50px;
    text-align: center;
    float: right;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .content{
    height:100%;
    width:50%;
    margin:0 auto;
  }

  iframe{
    height:80%;
    width:100%;
  }
}

.about-modal{
  display: flex;
  justify-content: center;
  // align-items:center;
  flex-wrap: wrap;
  position:relative;
  height: 100%;
  width:100%;
  .about-full{
    margin-top: 100px;
    padding:0 30px;
    text-align: justify;
  }
  .close{
    position:absolute;
    right: 0;
    top:0;
    display: block;
  }
}

.social-media{
  img{
    max-height: 30px;
    margin:0 5px;

    &:hover{
      opacity: 0.8;
    }
  }
}

.twitter{
  display:table;
  height: 100%;
  width: 50%;
  margin:40px auto 0 auto;
}

.twitter-section{
  text-align: center;
}

.twitter-cards{
  display:flex;
  justify-content: center;
}

// responsivity
.hamburger, .logo-mobile, .menu > .close, .menu > .logo-mobile{
  display: none;
}
.opened{
  display: block !important;
}
@media screen and (max-width: 1200px) {
  .twitter{
    width:90%;
  }
  .container{
    padding:30px;
  }

  .hamburger, .logo-mobile{
    display: block;
  }

  .logo{
    display: none;
  }

  .header{

    .menu{
      display: none;
      position:fixed;
      top:0;
      bottom:0;
      left:0;
      right:0;
      background: #010101;

      .logo-mobile{
        display: block;
        text-align:center;
      }

      .close{
        display: block;
        text-align:right;
        font-size:30px;
        padding:20px;
      }

      ul{
        li{
          text-align: center;
          display: inherit;
        }
      }
    }
  }

  .bio{
    width:100%;
  }

  .next-events{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items:center;

    .info{
      margin-bottom:30px;
    }

    .card{
      position:relative;
      flex-wrap: wrap;

      .btn{
        position:absolute;
        bottom:-20px;
        left:calc(50% - 101px);
      }
    }
  }

  .partners{
    text-align: center;
  }
  .partners-img{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .instagram-grid{
    grid-template-columns: 33% 33% 33%;
    height: 700px;
  }

  .instagram-grid li{
    height:100%;
    width: 100%;
  }

  .instagram-grid img{
    width:100%;
    height: 100%;
  }

  .instagram{
    position:relative;

    .btn{
      position:absolute;
      bottom:8px;
      margin: 0;
    }
  }

  footer{
    display: block;
    text-align: center;

    .logo-icon{
      margin:0;
    }

    nav{
      display: block;
      .nav-footer li{
        display: inherit;
        margin:20px 0;
      }
    }

    .social-media{
      margin:10px 0;
    }
  }

  .video-modal > .content{
    width:100%;
  }
}

@media screen and (max-width: 650px) {
  .instagram-grid{
    height: 400px;
  } 
}
</style>
